import clsx from "clsx";
import { ImSpinner2 } from "react-icons/im";

import type { JSX } from "react";

interface Props {
  size?: string;
  wrapperClassName?: string;
  className?: string;
  full?: boolean;
}

export const LoadingSpinner = ({ size = "1.5rem", wrapperClassName, className, full = false }: Props): JSX.Element => (
  <div
    data-testid="loading-spinner"
    className={clsx(wrapperClassName, full && "flex h-full w-full items-center justify-center")}
  >
    <ImSpinner2 size={size} className={clsx("animate-spin", className)} />
  </div>
);
